import { clone } from 'ramda';

import { clearGeo } from './clearGeo';
import { clearUndergroundTravel } from './clearUndergroundTravel';
import { resetTerms } from './helpers';
import { setRegionId } from './setRegionId';
import { type ILocation, type NonEmptyArray, type TJsonQuery } from './types';
import { needClearGeo } from './utils/needClearGeo';

export interface ISetLocationsParameters {
  next: NonEmptyArray<ILocation>;
  prev: NonEmptyArray<ILocation>;
}

export function setLocations(jsonQuery: TJsonQuery) {
  return ({ prev: prevLocations, next: nextLocations }: ISetLocationsParameters): TJsonQuery => {
    let nextJsonQuery = clone(jsonQuery);

    nextJsonQuery = resetTerms(['region'])(nextJsonQuery);

    const nextRegion = nextLocations.map(({ id }) => id);
    nextJsonQuery = setRegionId(nextJsonQuery)(nextRegion);

    if (needClearGeo(nextLocations, prevLocations)) {
      nextJsonQuery = clearGeo(nextJsonQuery)();
      nextJsonQuery = clearUndergroundTravel(nextJsonQuery)();
    }

    return nextJsonQuery;
  };
}
